import { Typography } from '@mui/material';
import React from 'react';
import ExpandableTextProps from './types';
import { CustomerNotesTypographySx } from './styles';
import { useExpandableText } from './hooks';

export const ExpandableText = (props: ExpandableTextProps) => {
  const { text, numLines, overrideSx } = props;
  const textRef = React.useRef<HTMLParagraphElement>(null);
  const lineHeight = overrideSx?.lineHeight || undefined;

  const { showMore, expanded, setExpanded } = useExpandableText(textRef);

  return (
    <Typography
      variant="body2"
      sx={CustomerNotesTypographySx(
        showMore,
        expanded,
        overrideSx,
        lineHeight,
        numLines
      )}
      ref={textRef}
    >
      <span>{text}</span>
      {showMore && (
        <span className="show-more-link" onClick={() => setExpanded(!expanded)}>
          {expanded ? 'Show less' : 'Show more'}
        </span>
      )}
    </Typography>
  );
};
